/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import 'components/following/follow-button/follow-button.css';

import(
  /* webpackChunkName: "follow-button-controller" */
  /* webpackPreload: true */
  'components/following/follow-button/follow-button-controller'
).then((controller) => {
  EezyStimulusApplication.register('follow-button', controller.default);
});
